import React from 'react';
import styles from './IconButton.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

const IconButton = React.forwardRef(function IconButton(
  {
    children,
    variant = 'ghost',
    size = 'md',
    tone = 'light',
    shape = 'circle',
    disabled = false,
    type = 'button',
    'aria-label': ariaLabel,
    className,
    ...rest
  },
  ref
) {
  if (!ariaLabel && process.env.NODE_ENV !== 'production') {
    console.warn('IconButton requires an aria-label for accessibility.');
  }
  return (
    <button
      ref={ref}
      type={type}
      aria-label={ariaLabel}
      disabled={disabled}
      className={clsx(
        styles.btn,
        styles[variant],
        styles[size],
        styles[shape],
        tone === 'dark' && styles.onDark,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
});

export default IconButton;
